module.exports = __webpack_public_path__ + "img/introduction-to-agentic-ai-and-agentic-workflow.3ca26401.jpg";